/* eslint-disable react/jsx-no-constructed-context-values */
import React, { createContext, useState } from 'react'
import IStep from '../interfaces/Step'

const DEFAULT_VALUE = {
	steps: [],
	setSteps: () => {},
	currentStep: 0,
	setCurrentStep: () => {},
}

export interface IStepsContext {
	steps: IStep[]
	setSteps: React.Dispatch<React.SetStateAction<IStep[]>>
	currentStep: number
	setCurrentStep: React.Dispatch<React.SetStateAction<number>>
	currentQuestion: number
	setCurrentQuestion: React.Dispatch<React.SetStateAction<number>>
}
const StepsContext = createContext<IStepsContext>({
	steps: DEFAULT_VALUE.steps,
	setSteps: DEFAULT_VALUE.setSteps,
	currentStep: DEFAULT_VALUE.currentStep,
	setCurrentStep: DEFAULT_VALUE.setCurrentStep,
	currentQuestion: DEFAULT_VALUE.currentStep,
	setCurrentQuestion: DEFAULT_VALUE.setCurrentStep,
})

function StepsContextProvider({
	children,
}: {
	children: React.ReactElement
}): React.ReactElement {
	const [state, setState] = useState<IStep[]>(DEFAULT_VALUE.steps)
	const [currentStep, setCurrentStep] = useState(DEFAULT_VALUE.currentStep)
	const [currentQuestion, setCurrentQuestion] = useState(
		DEFAULT_VALUE.currentStep,
	)
	return (
		// eslint-disable-next-line react/jsx-no-constructed-context-values
		<StepsContext.Provider
			value={{
				steps: state,
				setSteps: setState,
				currentStep,
				setCurrentStep,
				currentQuestion,
				setCurrentQuestion,
			}}
		>
			{children}
		</StepsContext.Provider>
	)
}

// function useStep(): IStepsContext {
// 	const context = React.useContext(StepsContext)
// 	if (context.currentQuestion && context.currentStep) {
// 		const questions = context.steps[context.currentStep]
// 		if (context.currentQuestion + 1 === questions.questions.length) {
// 			context.setCurrentStep(context.currentStep + 1)
// 			context.setCurrentQuestion(0)
// 		} else {
// 			context.setCurrentQuestion(context.currentQuestion + 1)
// 		}
// 	}
// 	return context
// }
export { StepsContextProvider }
export default StepsContext
